<!--
 * @Descripttion:
 * @version: 0.0.1
 * @Author: ZHJI
 * @Date: 2019-09-25 09:23:56
 * @LastEditors: ZHJI
 * @LastEditTime: 2019-11-12 17:10:00
 -->
<!--  -->
<template>
    <basicContainer>
        <div class="announcementManage">
            <!-- 主数据表 -->
            <easyCruds ref="mainTable" :tableInfo="mainTable"
                      @mainTableReload="mainTableReload"
                      @editRow="editRow"
                      @downloadDataFun='downloadDataFun'
                      @todownloadData='todownloadData'
                      @resrt="resrt"
                      @beforeEditFunctionName="beforeEditFunctionName"
                      @beforeViewFunctionName="beforeViewFunctionName"
                        v-if="hackReset">

                <template  slot="yrzForm">
                    <el-select
                            v-model="selectRole.value1"
                            multiple
                            collapse-tags
                            placeholder="请选择已任职角色"
                            @change="changeYRZ">
                        <el-option
                                v-for="item in selectRole.options1"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </template>


                <template  slot="wrzForm">
                    <el-select
                            v-model="selectRole.value2"
                            multiple
                            collapse-tags
                            placeholder="请选择未任职角色"
                            @change="changeWRZ">
                        <el-option
                                v-for="item in selectRole.options2"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </template>

                <template v-slot:formSlot="{data}">
                    <easyCruds ref="mainTable1" :tableInfo="mainTable1"
                              @mainTableReload1="mainTableReload1">

                        <template slot="zgxmForm" slot-scope="{row, index}" >
                            <div @click="openRoleNameModal(row, index)" :class=tablePageInfo.active>
                                <span v-if="row.zgxm == '' "   :class=tablePageInfo.display>
                                    提名
                                </span>
                                <span v-else>
                                    {{row.zgxm}}
                                </span>
                            </div>
                        </template>

                    </easyCruds>
                </template>

            </easyCruds>


            <!-- 导出数据 -->
            <el-dialog  title="导出数据" :visible.sync="downloadData.show" width="30%" top="15vh" :append-to-body="true">
                <el-row>
                    <el-form :inline="true"  ref="downloadView" :model="downloadData.form" label-suffix=":">
                        <el-col :span="24">
                            <el-form-item label="文件名称"  prop="fileName" :rules="[{ 'required': true, 'message': '请输入文件名' }]"  :required="true">
                                <el-input v-model="downloadData.form.fileName">
                                    <template slot="append">.xlsx</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-form>
                </el-row>
                <span slot="footer" >
              <el-button @click="downloadData.show = false">取 消</el-button>
              <el-button type="primary" @click="todownloadData">确 定</el-button>
            </span>
            </el-dialog>


            <!-- 人员角色 -->
            <el-dialog  title="人员列表" :visible.sync="roleNameData.show" top="15vh" :append-to-body="true" class="selectPersonModal">
                <el-row>

                    <el-form :inline="true" :model="tablePageInfo" class="demo-form-inline">
                        <el-form-item label="职工号：">
                            <el-input v-model="tablePageInfo.jszgh" placeholder="请输入职工号"></el-input>
                        </el-form-item>
                        <el-form-item label="姓名：">
                            <el-input v-model="tablePageInfo.xm" placeholder="请输入姓名"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="onSubmit">查询</el-button>
                            <el-button  @click="onEmpty">清空</el-button>
                        </el-form-item>
                    </el-form>

                    <el-row style="border: 1px solid #EBEEF5;">
                        <el-row style="padding: 15px 20px; color:#409EFF; border-bottom: 1px solid rgb(235, 238, 245);">
                            <i class="fa fa-table easyCrud_head_icon"></i> 选择人员
                        </el-row>
                        <el-row style="padding: 0 15px;">
                            <el-table
                                    border
                                    stripe
                                    :data="tablePageInfo.tableData"
                                    style="width: 100%; ">
                                <el-table-column  width="40" style="text-align: center;">
                                    <template slot-scope="scope">
                                        <el-radio v-model="tablePageInfo.radio" :label="scope.row.xm+'+'+scope.row.jszgh"></el-radio>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="jszgh"
                                        label="学号" style="color: rgba(0,0,0,.85)">
                                </el-table-column>
                                <el-table-column
                                        prop="xm"
                                        label="姓名" style="color: rgba(0,0,0,.85)">
                                </el-table-column>
                            </el-table>

                            <el-pagination
                                    background
                                    @size-change="handleSizeChange"
                                    @current-change="handleCurrentPageChange"
                                    :current-page=tablePageInfo.current
                                    :page-sizes="[10, 15, 20, 25]"
                                    :page-size=tablePageInfo.pageSize
                                    layout="total, sizes, prev, pager, next, jumper"
                                    :total=tablePageInfo.totalPage
                                    :pager-count="3"
                                    style=" text-align: center; margin-top: 30px; margin-bottom: 30px;">
                            </el-pagination>
                        </el-row>
                    </el-row>
                </el-row>
                <span slot="footer" >
              <el-button @click="roleNameData.show = false">取 消</el-button>
              <el-button type="primary" @click="saveSelectRole">保存</el-button>
            </span>
            </el-dialog>


        </div>
    </basicContainer>
</template>

<script>
import { getUserInfo } from '@/framework/util/auth'
import { dateFormat } from '@/framework/util/date'
import  {deepClone} from '@/framework/util/util'
export default {
  data() {
    return {

        //角色列表相关配置
        tablePageInfo: {
            active:'',
            flagView: false,
            bjdm:'',
            jszgh:'',
            xm:'',
            radio: '',
            tableData: [],
            totalPage:'',
            pageSize:10,
            current:'',
            tableDataArray: [],
            index:0,
            display:''
        },
        //select 已任职、未任职
        selectRole:{
            options1: [],
            value1: [],
            options2: [],
            value2: [],
            yrzArray:[],
            wrzArray:[],
            obj:{}
        },
        roleNameData:{
            show:false
        },
        hackReset: false,
        downloadData: {
            show: false,
            form: {
                excelTemplateType: '',
                fileName: '班级任职信息'
            }
        },
      mainTable: {
        buttonSetting: {
          resetFunctionName: 'resrt',
          allowAdd: false,
            allowEdit: true,
            beforeEditFunctionName: 'beforeEditFunctionName',
            beforeViewFunctionName: 'beforeViewFunctionName',
            editButtonArray:[{
                clickEvent:'editRow',
                type:'primary',
                buttonName:'保存',
                validate: true
            }],
          allowDelete: false,
          allowView: true,
          left: [{
            title: '导出',
            type: 'primary',
            clickEvent: 'downloadDataFun',
            icon: 'el-icon-download'
          }], right: [

          ]
        },
        header: {
          title: '学院信息'
        },
        table: {
          loading: false,
          height: 550,
          stripe: true,
          conditionLabelWidth: 'auto',
          selection: false,
          index: true,
          columns: [{
            prop: 'bmmc',
            label: '学院',
            isSearchCondition: true,

            disabled: [true, true, true],

            type: 'select',
            span: 12,
            dicData: []
          },{
              prop: 'yrz',
              label: '已任职',
              searchSlotName: 'yrzForm',
              isSearchCondition: true,
              type: 'select',
              showInTable: false,
              rows: 5,
              span: 12,
              view:[false, false, false],
              dicData: []
          }, {
              prop: 'wrz',
              label: '未任职',
              searchSlotName: 'wrzForm',
              isSearchCondition: true,
              type: 'select',
              showInTable: false,
              rows: 5,
              span: 12,
              view:[false, false, false],
              dicData: []
          }],
          operation: {
            width: '220'
          },
          tableData: [],
          paging: {
            currentPage: 1,
            pageSizes: [10, 15, 20, 25],
            pageSize: 10,
            total: 0
          },
          reload: 'mainTableReload',
          reloadConditions: {},
          addDefultValue: {}
        }

      },
        mainTable1: {
            buttonSetting: {
                 allowDelete: false,
                allowEdit:false,
                allowView: false,
                allowAdd: false
            },
            header: {
                title: '任职情况'
            },
            table: {
                loading: false,
                height: 450,
                stripe: true,
                conditionLabelWidth: 'auto',
                selection: false,
                index: true,
                columns: [{
                    prop: 'roleName',
                    label: '职位名称',
                    isSearchCondition: false,
                    span: 8,
                    dicData: []
                },  {
                    prop: 'zgxm',
                    label: '任命人',
                    slotName:'zgxmForm',
                    isSearchCondition: false,
                    type: 'select',
                    span: 8,
                    dicData: []
                }],
                operation: {
                    width: '220'
                },
                tableData: [],
                paging: false,
                reload: 'mainTableReload1',
                reloadConditions: {},
                addDefultValue: {}
            },
            tableArray:[],
            tableObj:{}


        },
      uploadView: {
        show: false,
        form: {
          excelTemplateType: '',
          fileName: '学院任职信息模板'
        }
      },

      uploadViewData: {
        label: '上传文件'
      },

      // 缓存column
      columnArray: []
    }
  },

  mounted() {
    // this.load(this.row)

    // 获取角色
    this.getColumn()

    /* 获取专业*/
    // this.getZY()
    //
    // /*获取班级*/
    // this.getBJ()


    /* 获取专业代码*/
   // this.getZYCode()


      //已任职
      this.getRoleSet()

      //未任职
      this.getRoleNotSet()
  },
  methods: {
      onEmpty:function(){
          this.tablePageInfo.jszgh = ''
          this.tablePageInfo.xm = ''
      },
      changeYRZ:function(event){
          this.selectRole.yrzArray = event
      },
      changeWRZ:function(event){
          this.selectRole.wrzArray = event
      },
      editRow:function(row, done, errorDone, optionType){

          let gradeJobSetList = this.mainTable1.tableArray
          let that = this
          that.newArray = []
          gradeJobSetList.forEach( (value,index,array)=>{
              value.type = 2
              if(!(value.zgh=='' || value.zgxm=='')){
                  that.newArray.push(value)
              }
          })

          let params = {
              bmdm:this.tablePageInfo.bmdm
          }
          this.$http.post('/collegeJobSet/saveOrUpdate', that.newArray, {params} ).then(response => {
              this.$message.success('更新成功')&&done()
              that.mainTableReload({ pageNum: 1, pageSize: 10 })
          }).catch(error => {
              this.$message.error(error.msg)
          })
      },

      saveSelectRole: function(){

          this.mainTable1.tableArray[this.tablePageInfo.index].zgxm = this.tablePageInfo.radio.substr(0,  this.tablePageInfo.radio.indexOf('+')) //根据radio的值截取name的值
          this.mainTable1.tableArray[this.tablePageInfo.index].zgh = this.tablePageInfo.radio.substr(this.tablePageInfo.radio.indexOf('+')+1,this.tablePageInfo.radio.length)//根据radio的值截取xh的值
          this.mainTable1.table.tableData = this.mainTable1.tableArray
          this.roleNameData.show=false
      },
      onSubmit: function(){
          let params = {
              bmdm: this.tablePageInfo.bmdm,
              pageNum: 1,
              pageSize: 10,
              zgh: this.tablePageInfo.jszgh,
              zgxm: this.tablePageInfo.xm
          }
          this.getRoleNameTable(params)
      },
      beforeEditFunctionName: function(row, type, callback) {

          let that = this
          let rowJson = row
          that.mainTable1.tableArray = []
          that.mainTable1.tableObj = {}
          that.tablePageInfo.active = 'active'
          that.tablePageInfo.display = 'show'
          that.tablePageInfo.flagView = false
          let params = {roleType: 2}
          that.$http.get('/roleSet/getRoleSet', {params} ).then(response => {
              for (let item in response.data) {
                  if(rowJson.options != null){
                      if(rowJson.options.length != 0 ){
                          for(let j=0; j<rowJson.options.length; j++){
                              if(response.data[item].id == rowJson.options[j].roleId){
                                  that.mainTable1.tableArray.push({
                                      zgxm: rowJson.options[j].zgxm,
                                      roleName: that.mainTable1.tableObj.name=response.data[item].name,
                                      roleId:response.data[item].id,
                                      zgh:rowJson.options[j].zgh,
                                      bmdm: rowJson.bmdm
                                  })
                                  rowJson.options.splice(j, 1);
                              }else{
                                  that.mainTable1.tableArray.push({
                                      zgxm:'' ,
                                      roleName:that.mainTable1.tableObj.name=response.data[item].name,
                                      roleId:response.data[item].id,
                                      zgh:'',
                                      bmdm: rowJson.bmdm
                                  })
                              }
                          }

                      }else {
                          that.mainTable1.tableArray.push({
                              zgxm: '',
                              roleName:that.mainTable1.tableObj.name=response.data[item].name,
                              roleId:response.data[item].id,
                              zgh:'',
                              bmdm: rowJson.bmdm
                          })
                      }
                  }else{
                      that.mainTable1.tableArray.push({
                          zgxm: '',
                          roleName:that.mainTable1.tableObj.name=response.data[item].name,
                          roleId:response.data[item].id,
                          zgh:'',
                          bmdm: rowJson.bmdm
                      })
                  }

              }


              that.mainTableReload1(params, callback)
          }).catch(error => {
              this.$message.error(error.msg)
          })



      },

      beforeViewFunctionName: function(row, type, callback) {
          let that = this
          let rowJson = row
          that.mainTable1.tableArray = []
          that.mainTable1.tableObj = {}
          that.tablePageInfo.active = 'active'
          that.tablePageInfo.display = 'show'
          that.tablePageInfo.flagView = false
          let params = {roleType: 2}
          that.$http.get('/roleSet/getRoleSet', {params} ).then(response => {
              for (let item in response.data) {
                  if(rowJson.options != null){
                      if(rowJson.options.length != 0 ){
                          for(let j=0; j<rowJson.options.length; j++){
                              if(response.data[item].id == rowJson.options[j].roleId){
                                  that.mainTable1.tableArray.push({
                                      zgxm: rowJson.options[j].zgxm,
                                      roleName: that.mainTable1.tableObj.name=response.data[item].name,
                                      roleId:response.data[item].id,
                                      zgh:rowJson.options[j].zgh,
                                      bmdm: rowJson.bmdm
                                  })
                                  rowJson.options.splice(j, 1);
                              }else{
                                  that.mainTable1.tableArray.push({
                                      zgxm:'' ,
                                      roleName:that.mainTable1.tableObj.name=response.data[item].name,
                                      roleId:response.data[item].id,
                                      zgh:'',
                                      bmdm: rowJson.bmdm
                                  })
                              }
                          }

                      }else {
                          that.mainTable1.tableArray.push({
                              zgxm: '',
                              roleName:that.mainTable1.tableObj.name=response.data[item].name,
                              roleId:response.data[item].id,
                              zgh:'',
                              bmdm: rowJson.bmdm
                          })
                      }
                  }else{
                      that.mainTable1.tableArray.push({
                          zgxm: '',
                          roleName:that.mainTable1.tableObj.name=response.data[item].name,
                          roleId:response.data[item].id,
                          zgh:'',
                          bmdm: rowJson.bmdm
                      })
                  }

              }



              that.tablePageInfo.active = ''
              that.tablePageInfo.display = 'hide'
              that.tablePageInfo.flagView = true
              that.mainTableReload1(params, callback)
          }).catch(error => {
              this.$message.error(error.msg)
          })


      },
      getRoleNameTable:function(params){
          this.$http.get('/collegeJobSet/getStudentByBmdm', {
              params
          }).then(response => {
                  this.tablePageInfo.tableData = response.data.records
                  this.tablePageInfo.totalPage = response.data.total
                  this.tablePageInfo.current = response.data.current
              }
          ).catch(erro => {
              return this.$message.error(erro.msg)
          })
      },
      handleCurrentPageChange(val) {
          this.getRoleNameTable({bmdm: this.tablePageInfo.bmdm, pageNum: val, pageSize: this.tablePageInfo.pageSize});
      },
      handleSizeChange(val){
          this.pageSize = val
          this.getRoleNameTable({bmdm: this.tablePageInfo.bmdm, pageNum: this.tablePageInfo.current, pageSize: val});
      },
      openRoleNameModal: function(row,index){
          if(this.tablePageInfo.flagView){
              return
          }else {
              this.tablePageInfo.bmdm = row.bmdm
              let params = {
                  /*bmdm: this.tablePageInfo.bmdm,*/
                  pageNum: 1,
                  pageSize: 10,
              }
              this.$http.get('/collegeJobSet/getStudentByBmdm', {
                  params
              }).then(response => {
                      this.tablePageInfo.tableData = response.data.records
                      this.tablePageInfo.totalPage = response.data.total
                      this.tablePageInfo.current = response.data.current
                      this.tablePageInfo.index = index
                      this.roleNameData.show = true
                  }
              ).catch(erro => {
                  return this.$message.error(erro.msg)
              })
              this.roleNameData.show = true
          }
      },

    dataFilter: function(data) {
    },

      getRoleSet: function(){
          let params = {roleType:2}
          this.$http.get('/roleSet/getRoleSet',{params}).then(response => {
              response.data.forEach(item => {
                  this.selectRole.options1.push({
                      label: item.name,
                      value: item.id
                  })
              })


          }).catch(error => {
              this.$message.error(error.msg)
          })
      },

      getRoleNotSet: function(){
          let params = {roleType:2}
          this.$http.get('/roleSet/getRoleNotSet',{params}).then(response => {
              response.data.forEach(item => {
                  this.selectRole.options2.push({
                      label: item.name,
                      value: item.id
                  })
              })


          }).catch(error => {
              this.$message.error(error.msg)
          })
      },

    /*beforeEditFunctionName: function(row, type, callback) {
    },*/
      getColumn: function() {
          let that = this
          let params = {roleType: 2}
          that.$http.get('/roleSet/getRoleSet',{params} ).then(response => {
              for (let item in response.data) {
                  that.columnArray = deepClone(this.mainTable.table.columns)
                  that.columnArray.push({
                      label: response.data[item].name,
                      prop: response.data[item].id,
                      view:[false, false, false],
                      dataFilter: this.dataFilter(this.mainTable.table.columns)
                  })
                  that.mainTable.table.columns = deepClone(that.columnArray)
                  that.hackReset = true
              }
              that.mainTableReload({ pageNum: 1, pageSize: 10 })
          }).catch(error => {
              that.$message.error(error.msg)
          })
      },

    resrt: function() {
        /* 获取学院*/
        this.getXY()
        this.selectRole.value2 = ''
        this.selectRole.value1 = ''
        this.selectRole.yrzArray = []
        this.selectRole.wrzArray = []
      // /*获取专业*/
      // this.getZY()
      //
      // /*获取班级*/
      // this.getBJ()
    },

    mainTableReload: function(params, arr) {

      params.bmdm = params.bmmc
      delete params['bmmc']
        params.yrzlx = this.selectRole.yrzArray
        params.wrzlx = this.selectRole.wrzArray
      this.mainTable.table.loading = true
      this.$http.post('/collegeJobSet/query', null, {
        params
      }).then(response => {
        this.mainTable.table.loading = false
        // 成功之后的数据
              for(let i=0; i<response.data.records.length; i++){
                  if(response.data.records[i].options !== null){
                      for(let j=0; j<response.data.records[i].options.length; j++){
                          response.data.records[i][(response.data.records[i].options[j].roleId)] = response.data.records[i].options[j].zgxm

                      }

                  }
              }
        this.mainTable.table.tableData = response.data.records
        this.mainTable.table.paging.total = response.data.total || response.data.records.length
          /* 获取学院*/
        this.getXY()
      }
      ).catch(erro => {
        return this.$message.error(erro.msg)
      })
    },
      mainTableReload1: function(params, callback) {
          this.mainTable1.table.tableData =  this.mainTable1.tableArray
          callback()
      },
    getXY: function() {
      this.$http.post('/college/getNewCollegeCode').then(response => {
        let result = []
        response.data.forEach(element => {
          result.push({
            label: element.bmmc,
            value: element.bmdm
          })
        })
        this.$refs.mainTable.setColumnSeting('bmmc', 'dicData', result)
      }).catch(error => {
        this.$message.error(error.msg)
      })
    },


    downloadDataFun: function() {
      this.downloadData.show = true
      if (this.$refs.downloadData) {
        this.$refs.downloadData.resetFields()
      }
        let ststemDate = this.showSystemDate()
      this.downloadData.form = {
        excelTemplateType: '',
        fileName: '学院任职信息_'+ststemDate
      }
    },
    todownloadData: function() {
        let params = this.$refs.mainTable.getReloadConditions()
        params.bmdm = params.bmmc
        delete params['bmmc']
        params.yrzlx = this.selectRole.yrzArray
        params.wrzlx = this.selectRole.wrzArray
        params.fileName = this.downloadData.form.fileName + '.xlsx'
        params.doDownload = true

      this.$refs.downloadView.validate((valid) => {
        if (valid) {
          this.$downloadFile.post('/collegeJobSet/collegeJobExport',null, {params}).then(response => {
              this.$message.success(response.msg)
              this.downloadData.show = false
          }).catch(error => {
            this.$message.error(error.msg)
          })
        }
      })
    },
      showSystemDate: function(){
          let nowDate = new Date();
          let date = {
              year: nowDate.getFullYear(),
              month: nowDate.getMonth() + 1,
              date: nowDate.getDate(),
          }
          if(date.month<10){
              date.month = '0'+date.month
          }
          if(date.date<10){
              date.date = '0'+date.date
          }
          let systemDate = date.year + '-' + date.month  + '-' + date.date;
          return systemDate
      }

  }
}
</script>

<style lang='scss'>

    .quill-editor {
        height: 300px;
    }
    .easyCrud .el-form-item {
        height: 44px !important;
    }
</style>
<style lang='scss' scoped>
    .file {
        z-index: 999;
        opacity: 0;
        position: absolute;
        left: 2px;
        width: 140px;
        cursor: pointer;
        height: 44px;
    }
    .file_btn {
        position: absolute;
        left: 2px;
        width: auto;
        z-index: 0;
    }

    .easyCrud .el-form-item {
        height: 44px !important;
    }

    body .el-card.is-always-shadow {
        border: 1px solid #EBEEF5 !important;
    }
    .avue-crud {
        margin: 0 auto;
        width: 99%;
    }

</style>

<style>
    .active {
        cursor: pointer;
        color: #409EFF;
        text-decoration: underline;
    }
    .selectPersonModal .el-radio__label {
        display: none  !important;
    }

    .el-table th>.cell {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }
    .el-table th {
        background-color: #fafafa !important;
    }
    .el-table thead {
        color: rgba(0,0,0,.85) !important;
    }
    .el-table td, .el-table th {
        padding: 10px 0;
    }
    .el-table--enable-row-hover .el-table__body tr:hover>td{
        background-color: #ecf5ff;
    }
    .selectPersonModal .el-radio__label {
        display: none  !important;
    }
    .show {
        display: block;
    }
    .hide {
        display: none;
    }
</style>
